import React, { useState } from 'react';
import Lightbox from '../../components/Lightbox/Lightbox';
import floorPlanStyles from './FloorPlansContent.module.css';
import styles from './KitchenTabContent.module.css';

const KitchenTabContent = () => {
    const [currentImageIndex, setCurrentImageIndex] = useState(0);
    const [isLightboxOpen, setIsLightboxOpen] = useState(false);

    const [activeArea, setActiveArea] = useState({
        title: 'Kitchen & Pantry',
        info: 'A fully equipped kitchen for meal preparation, featuring a walk-in pantry for food storage.',
        roomImages: [
            '/images/display/rooms/first-floor/kitchen/dji-20260111143011-0091-d.webp',
            '/images/display/rooms/first-floor/kitchen/dji-20260111143034-0092-d.webp',
            '/images/display/rooms/first-floor/pantry/dji-20260111141257-0057-d.webp'
        ],
    });

    const handleNextImage = () => {
        setCurrentImageIndex(prevIndex => (prevIndex + 1) % activeArea.roomImages.length);
    };

    const handlePrevImage = () => {
        setCurrentImageIndex(prevIndex => (prevIndex - 1 + activeArea.roomImages.length) % activeArea.roomImages.length);
    };

    return (
        <section className={floorPlanStyles.mainContainer}>
            <div className={styles.kitchenWrapper}>
                <div className={styles.infoColumn}>
                    <div className={floorPlanStyles.activeRoomInfo} style={{ flexDirection: 'column', alignItems: 'center', textAlign: 'center' }}>
                        <div className={floorPlanStyles.infoImage} style={{ display: 'flex', justifyContent: 'center', position: 'relative', width: '100%', maxWidth: '800px' }}>
                            <img
                                src={activeArea.roomImages[currentImageIndex]}
                                alt={`${activeArea.title} view ${currentImageIndex + 1}`}
                                onClick={() => setIsLightboxOpen(true)}
                                style={{ width: '100%', height: 'auto', borderRadius: '8px', objectFit: 'cover', maxHeight: '500px', cursor: 'pointer' }}
                                title="Click to view larger image"
                            />
                            {activeArea.roomImages.length > 1 && (
                                <>
                                    <button onClick={handlePrevImage} className={`${floorPlanStyles.galleryButton} ${floorPlanStyles.prevButton}`}>&#8249;</button>
                                    <button onClick={handleNextImage} className={`${floorPlanStyles.galleryButton} ${floorPlanStyles.nextButton}`}>&#8250;</button>
                                </>
                            )}
                        </div>
                        <div className={floorPlanStyles.infoText} style={{ marginTop: '20px' }}>
                            <h3>{activeArea.title}</h3>
                            <p>{activeArea.info}</p>
                        </div>
                    </div>
                </div>
            </div>
            {isLightboxOpen && activeArea.roomImages.length > 0 && (
                <Lightbox
                    images={activeArea.roomImages}
                    initialIndex={currentImageIndex}
                    onClose={() => setIsLightboxOpen(false)}
                />
            )}
        </section>
    );
};

export default KitchenTabContent;
